<template>
    <div class="default-selector" :class="className">
        <template v-for="(data, index) in candidates" :key="index">
            <div class="selector-candidate" :class="receiveName(data)" @click="click(data.value)">
                {{ data.label }}
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { DefaultSelectorPropsOption, DefaultSelectorEmits } from "./src";
import { useComposable } from "./src/composable";

//* 获取公共属性
const define = defineProps(DefaultSelectorPropsOption);
const emit = defineEmits(DefaultSelectorEmits);

//* 组合函数
const { methods, computeds } = useComposable(define, emit);
const { click, receiveName } = methods;
const { className } = computeds
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
